import styled from 'styled-components';
import { plainButton, primaryButton } from '../../../../styles/buttons';

export const ModalButtons = styled.div`
  display: flex;
  //justify-content: space-between;
  flex-direction: column;
  gap: 8px;
`;

export const ModalPrimaryButton = styled.button`
  ${primaryButton};
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  flex-grow: 1;
`;

export const ModalSecondaryButton = styled(plainButton)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 16px;
  color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
  cursor: pointer;
`;

export const ModalImage = styled.img`
  max-width: 166px;
  margin-bottom: 16px;
`;

export const ModalTitle = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;

export const ModalBody = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  .chat-gpt-disclaimer-modal & {
    p {
      margin-bottom: 16px;
    }
    a {
      text-decoration: underline;
      font-weight: bold;
    }
  }
`;
